/*
 * @Author: Json Chen
 * @Date: 2021-07-22 09:47:50
 * @LastEditTime: 2022-06-14 10:06:46
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelLogistics/index.tsx
 */
import CommonHeader from '@/src/components/CommonHeader';
import Configuration from '@/src/components/Configuration/Configuration';
import NoPermission from '@/src/components/NoPermission';
//import { useStoreCountries } from '@/src/pages/Settings/Components/SelectCountryArea';
import MultiLangDropDown from '@/src/constrains/SalesChannelMultiLanguageSelect/MultiLangDropDown';
import useBreadCrumbData from '@/src/pages/SalesCannelVersion/Hooks/useBreadCrumbData';
import { SalesChannelModeAccessControlHOC } from 'src/constrains/SalesChannelModeAccessControl';
import {
  getLogisticsMethod,
  getLogisticsSetting,
  getParcelLockers,
  setLogisticsSetting,
} from '@/src/request/salesChannel/setting/logistic';
import {
  isUserValid,
  salesChannelResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from '@/src/types/common/resources';
import { useRequest } from 'ahooks';
import { Form, Spin, message } from 'antd';
import _, { get } from 'lodash';
import moment from 'moment';
import React from 'react';
import { useHistory, useParams } from 'react-router';
import SalesChannelHOC, {
  SelectHOC,
} from 'src/constrains/SalesChannelHOC/SalesChannelHOC';
import { timeoutScroll } from 'src/tools/helper';
import {
  EnumMultiLanguageType,
  useQueryLanguageListContentEditor,
} from 'src/constrains/SalesChannelMultiLanguageSelect';
import { EnumSalesChannelMultiLanguage } from 'src/types/server/params';
import AvailableClickAndCollectTime, {
  AfterPaymentCompleteType,
  AvailableTimeType,
} from './Components/AvailableClickAndCollectTime';
//import VirtualProduct from './Components/VirtualProduct';
import DeliveryMethod from './Components/DeliveryMethod';
import LogisticMethods from './Components/LogisticMethods';
//import ShippingZone from './Components/ShippingZone';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import ParcelLockers, { regionTypeList } from './Components/ParcelLockers';
import PickupLocations from './Components/PickupLocations';
import ShippingRateTax from './Components/ShippingRateTax';
import Warehouse from './Components/Warehouse';
import styles from './style.module.less';
import { LogisticMethod, DeliveryOptionType } from './type';

const shouldUpdate = (p, c, method: LogisticMethod) => {
  const pItem =
    (p.logisticsMethods || []).find((i) => i.logisticsMethod === method) || {};
  const cItem =
    (c.logisticsMethods || []).find((i) => i.logisticsMethod === method) || {};
  return cItem && pItem.checked !== cItem.checked;
};

const permissions = (uuid: string) => {
  const view_logistic_setting = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        category: EnumCategory.SalesChannelSettings,
        subCategory: EnumSubCategory.ChannelLogistics,
        operation: EnumOperation.view_logistic_setting,
        uuid,
      }),
    ],
  });

  const edit_logistics_setting = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        category: EnumCategory.SalesChannelSettings,
        subCategory: EnumSubCategory.ChannelLogistics,
        operation: EnumOperation.edit_logistics_setting,
        uuid,
      }),
    ],
  });

  return {
    view_logistic_setting,
    edit_logistics_setting,
  };
};

const SalesChannelLogistics = ({ isPrimary }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const history = useHistory();
  const currentLanguage = useQueryLanguageListContentEditor();
  const { uuid } = useParams<{ uuid: string }>();
  const { view_logistic_setting, edit_logistics_setting } = permissions(uuid);
  //const { list: countries = [] } = useStoreCountries();

  const [data, setData] = React.useState(null);
  const [logisticsMethods, setLogisticsMethods] = React.useState({});

  const [form] = Form.useForm();
  // 保存按钮是否置灰
  const [onSaveDisable, setOnSaveDisable] = React.useState<boolean>(true);

  const { loading: breadCrumbLoading, breadcrumbData } = useBreadCrumbData({
    lastSecond: getI18n('general.sider.settings'),
    lastOne: getI18n('salesChannelSettings.config.logistics'),
  });

  const { data: parcelLockers, run: runGetParcelLockers } = useRequest(
    (storeWarehouseUuid) => getParcelLockers(storeWarehouseUuid),
    {
      manual: true,
    },
  );

  const { run: runGetLogisticMethod } = useRequest(
    (storeWarehouseUuid) => getLogisticsMethod(storeWarehouseUuid),
    {
      manual: true,
      onSuccess: (data, params) => {
        if (logisticsMethods[params[0]]) {
          const logisticsMethodsData = data.map((item) => {
            const logisticsMethodIndex = logisticsMethods[params[0]].filter(
              (o) => o.logisticsMethod === item.logisticsMethod,
            );
            return {
              ...item,
              remarks: ((logisticsMethodIndex || [])[0] || {}).remarks,
              title: ((logisticsMethodIndex || [])[0] || {}).title,
            };
          });
          form.setFieldsValue({
            logisticsMethods: logisticsMethodsData,
          });
        } else {
          form.setFieldsValue({ logisticsMethods: data });
        }
      },
    },
  );

  const onValuesChange = () => {
    if (onSaveDisable) {
      setOnSaveDisable(!onSaveDisable);
    }
  };

  const onSubmit = () => {
    form
      .validateFields()
      .then((res) => {
        const {
          pickupAvailableTime: {
            till: {
              specificType = AfterPaymentCompleteType.AfterPaymentComplete,
              beforeDate = '',
            } = {},
            from: { type = '' } = {},
          } = {},
        } = res;
        const virtualProductLogisticsMethod = {
          sendBy: res.sendBy || data.sendBy,
          emailTemplate: res.emailTemplate || data.emailTemplate,
        };
        const params = {
          salesChannelUuid: uuid,
          logisticsMethods: res.logisticsMethods || data.logisticsMethods,
          warehouseLocation: res.warehouseLocation || data.warehouseLocation,
          pickupLocations: res.pickupLocations || data.pickupLocations,
          // shippingRates: res.shippingRates || data.shippingRates,
          lockers: res.lockers || data.lockers,
          virtualProductLogisticsMethod,

          pickupAvailableTime: {
            from: get(res, 'pickupAvailableTime.from', {}),
            till: {
              ...get(res, 'pickupAvailableTime.till', {}),
              specificType:
                type == AvailableTimeType.SpecificDays
                  ? AfterPaymentCompleteType.AfterPaymentComplete
                  : specificType,
              beforeDate: beforeDate
                ? moment(beforeDate).format('YYYY-MM-DD')
                : '',
            },
          },
          deliveryMethods: res.deliveryMethods || data.deliveryMethods,
          taxRulesEnabled: res.taxRulesEnabled,
          taxRules: res.taxRules,
        };
        _setLogisticsSetting(params);
      })
      .catch((e) => {
        const isDeliveryMethodError =
          e.errorFields[0]?.name[0] === 'deliveryMethods';

        if (isDeliveryMethodError) {
          timeoutScroll('salesChannelLogisticsDeliveryMethod');
        }
      });
  };

  const onGoBackClick = () => {
    history.push(`/salesChannel/settings/${uuid}`);
  };

  const { loading: getLogisticsSettingLoading, run: _getLogisticsSetting } =
    useRequest(
      () =>
        getLogisticsSetting(uuid, {
          [EnumSalesChannelMultiLanguage.multiLanguageInParams]: true,
        }),
      {
        manual: true,
        cacheKey: 'LogisticsSetting',
        ready: !!view_logistic_setting,
        onSuccess(result) {
          const pickupAvailableTime = get(result, 'pickupAvailableTime', {});
          const {
            till = {},
            till: { beforeDate = '' } = {},
            from = {},
          } = pickupAvailableTime || {};
          setData(result);
          setLogisticsMethods({
            [get(result, 'warehouseLocation.uuid')]: result.logisticsMethods,
          });
          runGetParcelLockers(get(result, 'warehouseLocation.uuid', ''));
          // runGetLogisticMethod(get(result, 'warehouseLocation.uuid', ''));
          form.setFieldsValue({
            warehouseLocation: result.warehouseLocation,
            shippingRates: result.shippingRates,
            lockers: result.lockers,
            logisticsMethods: result.logisticsMethods,
            pickupLocations: result.pickupLocations,
            deliveryMethods: result.deliveryMethods,
            pickupAvailableTime: {
              from,
              till: {
                ...till,
                beforeDate: beforeDate ? moment(beforeDate) : '',
              },
            },
            taxRulesEnabled: result.taxRulesEnabled,
            taxRules: result.taxRules,
            sendBy: _.get(
              result,
              'virtualProductLogisticsMethod.sendBy',
              'Email',
            ),
            emailTemplate: _.get(
              result,
              'virtualProductLogisticsMethod.emailTemplate',
              '',
            ),
          });
        },
      },
    );

  const { loading: setLogisticsSettingLoading, run: _setLogisticsSetting } =
    useRequest(
      (params) =>
        setLogisticsSetting(params, {
          [EnumSalesChannelMultiLanguage.multiLanguageInParams]: true,
        }),
      {
        manual: true,
        onSuccess(result) {
          message.success(getI18n('general.savesuccess'));
          history.push(`/salesChannel/settings/${uuid}`);
        },
      },
    );

  React.useEffect(() => {
    if (view_logistic_setting) {
      _getLogisticsSetting();
    }
  }, [currentLanguage]);

  return view_logistic_setting ? (
    <div className={styles.container}>
      <Spin
        spinning={
          breadCrumbLoading ||
          getLogisticsSettingLoading ||
          setLogisticsSettingLoading
        }>
        <Form
          name={'languageSetting'}
          form={form}
          onValuesChange={onValuesChange}
          className={styles.editForm}>
          <CommonHeader
            breadcrumbData={breadcrumbData}
            onSaveDisable={onSaveDisable || !edit_logistics_setting}
            onSubmit={onSubmit}
            onDiscard={onGoBackClick}
            onGoBackClick={onGoBackClick}
            extraLeft={
              <div style={{ marginRight: 8 }}>
                <MultiLangDropDown
                  hasModified={!onSaveDisable}
                  salesChannelUuidKey='uuid'
                  customType={
                    EnumMultiLanguageType.SalesChannelSettingsLogistics
                  }
                />
              </div>
            }
          />
          <div className={styles.commonContainer}>
            {isPrimary && (
              <div
                className={`${styles.mainContainer} ${styles.logisticMethod}`}>
                <div className={styles.header}>
                  <div className={styles.title}>
                    {getI18n(
                      'salesChannelLogistics.index.salesChannelWarehouse',
                    )}
                  </div>
                </div>
                <div className={styles.content}>
                  <Warehouse
                    salesChannelUuid={uuid}
                    form={form}
                    runGetLogisticMethod={runGetLogisticMethod}
                    runGetParcelLockers={runGetParcelLockers}
                    disableEdit={!edit_logistics_setting}
                  />
                </div>
              </div>
            )}
            <div className={`${styles.mainContainer} ${styles.logisticMethod}`}>
              <div className={styles.header}>
                <div className={styles.title}>
                  {getI18n('general.logisticMethod')}
                </div>
                <div className={styles.description}>
                  {getI18n('salesChannelLogistics.index.logisticMethodTip')}
                </div>
              </div>
              <div className={styles.content}>
                <Form.Item
                  name={'logisticsMethods'}
                  rules={[
                    {
                      validator: async (x, value) => {
                        const selectedRowKeys = (value || [])
                          .filter((l) => l.checked)
                          .map((l) => l.logisticsMethod);
                        if (!selectedRowKeys.length) {
                          return Promise.reject(
                            new Error(
                              getI18n(
                                'salesChannelLogistics.index.logisticMethodValid',
                              ),
                            ),
                          );
                        }
                      },
                    },
                  ]}>
                  <LogisticMethods
                    isPrimary={isPrimary}
                    disableEdit={!edit_logistics_setting}
                  />
                </Form.Item>
                <div className={styles.configurationtext}>
                  <Configuration
                    configStart={getI18n(
                      'salesChannelLogistics.index.logisticsMethodsStart',
                    )}
                    configEnd={getI18n(
                      'salesChannelLogistics.index.logisticsMethodsEnd',
                    )}
                    configLink={`${getI18n(
                      'salesChannelLogistics.index.logisticsMethodsLink',
                    )} `}
                    linkTo='/settings/logistics'
                  />
                </div>
              </div>
            </div>

            <div className={`${styles.mainContainer} ${styles.logisticMethod}`}>
              <div className={styles.header}>
                <div className={styles.title}>
                  {getI18n('salesChannelLogistics.index.shippingRateTax')}
                </div>
              </div>
              <div className={styles.content}>
                <ShippingRateTax disableEdit={!edit_logistics_setting} />
              </div>
            </div>
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, curValues) =>
                prevValues.logisticsMethods !== curValues.logisticsMethods
              }>
              {({ getFieldValue }: any) => {
                const logisticsMethods = getFieldValue('logisticsMethods');
                const deliverySetting = (logisticsMethods || []).filter(
                  (o) =>
                    o.logisticsMethod == LogisticMethod.Delivery && o.checked,
                );
                return deliverySetting.length ? (
                  <div
                    className={`${styles.mainContainer} ${styles.logisticMethod}`}>
                    <div className={styles.header}>
                      <div className={styles.title}>
                        {getI18n('general.deliveryMethod')}
                      </div>
                      <div className={styles.description}>
                        {getI18n(
                          'salesChannelLogistics.index.deliveryMethodDesc',
                        )}
                      </div>
                    </div>
                    <div className={styles.content}>
                      <Form.Item
                        name='deliveryMethods'
                        rules={[
                          {
                            validator: async (_, value) => {
                              if (
                                !value ||
                                !value.some((item) => item.checked === true)
                              ) {
                                return Promise.reject(
                                  new Error(
                                    getI18n(
                                      'salesChannelLogistics.index.deliveryoptiontips',
                                    ),
                                  ),
                                );
                              }

                              const checkedItems = value.filter(
                                (item) => item.checked === true,
                              );

                              if (
                                !checkedItems.some(
                                  (item) =>
                                    item.type === DeliveryOptionType.All,
                                )
                              ) {
                                return Promise.reject(
                                  getI18n(
                                    'salesChannelLogistics.index.deliveryoptiontips2',
                                  ),
                                );
                              }

                              return Promise.resolve();
                            },
                          },
                        ]}>
                        <DeliveryMethod
                          isPrimary={isPrimary}
                          disableEdit={!edit_logistics_setting}
                        />
                      </Form.Item>
                    </div>
                  </div>
                ) : null;
              }}
            </Form.Item>

            {/* Available Parcel Locker */}
            {isPrimary && (
              <Form.Item
                noStyle
                shouldUpdate={(p, c) =>
                  shouldUpdate(p, c, LogisticMethod.ParcelLocker)
                }>
                {({ getFieldValue }) => {
                  const logisticsMethods =
                    getFieldValue('logisticsMethods') || [];

                  const checked = (
                    logisticsMethods.find(
                      (i) => i.logisticsMethod === LogisticMethod.ParcelLocker,
                    ) || {}
                  ).checked;

                  return (
                    checked && (
                      <div
                        className={`${styles.parcelLocker} ${styles.mainContainer}`}>
                        <div className={styles.header}>
                          <div className={styles.title}>
                            {getI18n(
                              'salesChannelLogistics.index.availableParcelLocker',
                            )}
                          </div>
                          <div className={styles.description}>
                            {getI18n(
                              'salesChannelLogistics.index.availableParcelLockerDesc',
                            )}
                          </div>
                        </div>
                        <div
                          className={`${styles.content} ${styles.availableParcelLocker}`}>
                          <Form.Item
                            name={'lockers'}
                            rules={[
                              {
                                validator(_, value) {
                                  if (
                                    (value || []).every((v) =>
                                      v.types.every((t) => !t.checked),
                                    )
                                  ) {
                                    return Promise.reject(
                                      new Error(
                                        getI18n(
                                          'salesChannelLogistics.index.lockersError',
                                        ),
                                      ),
                                    );
                                  }
                                  const errList = [];
                                  value.forEach((item) => {
                                    if (!item.storeParcelLockerUuid) {
                                      errList.push(
                                        `${getI18n(
                                          'salesChannelLogistics.index.lockersError2',
                                        )} ${regionTypeList[item.region]}.`,
                                      );
                                    }
                                  });

                                  if (errList.length) {
                                    return Promise.reject(
                                      new Error(errList[0]),
                                    );
                                  }

                                  return Promise.resolve();
                                },
                              },
                            ]}>
                            <ParcelLockers
                              parcelLockers={parcelLockers}
                              disableEdit={!edit_logistics_setting}
                              // parcelLockerError={parcelLockerError}
                            />
                          </Form.Item>
                        </div>
                      </div>
                    )
                  );
                }}
              </Form.Item>
            )}

            {/* Avaliable Pickup Locations */}
            <Form.Item
              noStyle
              shouldUpdate={(p, c) =>
                shouldUpdate(p, c, LogisticMethod.ClickCollect)
              }>
              {({ getFieldValue }) => {
                const logisticsMethods =
                  getFieldValue('logisticsMethods') || [];

                const checked = (
                  logisticsMethods.find(
                    (i) => i.logisticsMethod === LogisticMethod.ClickCollect,
                  ) || {}
                ).checked;

                return (
                  checked && (
                    <div
                      className={`${styles.pickupLocations} ${styles.mainContainer}`}>
                      <div className={styles.header}>
                        <div className={styles.title}>
                          {getI18n(
                            'salesChannelLogistics.index.avaliablePickupLocations',
                          )}
                        </div>
                        <div className={styles.description}>
                          {getI18n(
                            'salesChannelLogistics.index.avaliablePickupLocationsDesc',
                          )}
                        </div>
                      </div>
                      <div className={styles.content}>
                        <Form.Item name={'pickupLocations'}>
                          <PickupLocations
                            isPrimary={isPrimary}
                            disableEdit={!edit_logistics_setting}
                          />
                        </Form.Item>
                      </div>
                    </div>
                  )
                );
              }}
            </Form.Item>
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, curValues) =>
                prevValues.logisticsMethods !== curValues.logisticsMethods
              }>
              {({ getFieldValue }: any) => {
                const logisticsMethods = getFieldValue('logisticsMethods');
                const clickAndCollectSetting = (logisticsMethods || []).filter(
                  (o) =>
                    o.logisticsMethod == LogisticMethod.ClickCollect &&
                    o.checked,
                );
                return clickAndCollectSetting.length ? (
                  <div
                    className={`${styles.mainContainer} ${styles.logisticMethod}`}>
                    <div className={styles.header}>
                      <div className={styles.title}>
                        {getI18n(
                          'salesChannelLogistics.index.availableClickAndCollectTime',
                        )}
                      </div>
                      <div className={styles.description}>
                        {getI18n(
                          'salesChannelLogistics.index.availableClickAndCollectTimeDesc',
                        )}
                      </div>
                    </div>
                    <div className={styles.content}>
                      <Form.Item name={'clickAndCollectTime'}>
                        <AvailableClickAndCollectTime
                          form={form}
                          disableEdit={!edit_logistics_setting}
                        />
                      </Form.Item>
                    </div>
                  </div>
                ) : null;
              }}
            </Form.Item>
          </div>
        </Form>
      </Spin>
    </div>
  ) : (
    <NoPermission />
  );
};

export default SalesChannelModeAccessControlHOC(
  SalesChannelHOC(SelectHOC(SalesChannelLogistics), {
    type: EnumMultiLanguageType.SalesChannelSettingsLogistics,
  }),
);
